export default {
  drawerTitle: 'Sync',
  drawerClose: 'Close',
  taskPhotoDeleteNeedsConnection: 'Deleting task photos requires an internet connection.',
  taskPhotoNotSyncedYet: 'This photo has not synced yet; you can delete it once it uploads.',
  taskPhotoEditNeedsConnection: 'Editing a task photo requires an internet connection.',
  taskPhotoEditNotSyncedYet: 'This photo has not synced yet; you can edit it once it uploads.',
  taskPhotoEditFailed: 'Could not save the edited photo. Please try again.',
  taskPhotoSyncing: 'Syncing the photo…',
  taskPhotoBusy: 'Wait for the previous photo operation to finish.',
  taskPhotoDeleteFailed: 'Could not delete the photo. Please try again.',
  taskPhotoEditOldNotRemoved: 'The edited photo was saved, but the previous one could not be removed. Please delete it manually.',
  allSynced: 'All synced',
  onePending: '1 pending change',
  pendingChanges: '{count} pending changes',
  syncing: 'Syncing…',
  failedCount: '{count} failed',
  reauthNeeded: 'Sign in again to sync your pending changes',
  pendingSection: 'Pending',
  failedSection: 'Failed',
  retry: 'Retry',
  discard: 'Discard',
  empty: 'Nothing pending',
  syncNow: 'Sync now',
  statusQueued: 'Queued',
  statusSyncing: 'Syncing',
  statusSynced: 'Synced',
  statusFailed: 'Failed',
  occurrenceFinished: 'Form finished successfully.',
  occurrenceFinishedOffline: 'Form finished offline. It will be sent automatically when you reconnect.',
  occurrenceFinishError: 'Could not finish the audit. Your answers and photos are safe: reconnect and try again or contact support.',
  occurrenceFinishDeferred: 'Audit finished. Your work is saved and will be sent on its own once you are back online.',
  deferredCloseHint: 'No connection: when you finish, the audit is saved and sent on its own once you are back online.',
  deferredClosePending: 'This audit is already finished and saved on this device. It will be sent on its own once you are back online.',
  // TKT-2182: the email/PDF are rendered by the BACKEND. While the close is still in the outbox the
  // server sees the audit as OPEN and returns "Not finished" with a 0 score, so nothing is sent.
  occurrenceSyncingBeforeDocument: 'Finishing the audit sync before sending it...',
  occurrencePendingForDocument: 'The audit is still syncing. Wait for it to finish and try again so an incomplete PDF is not sent.',
  occurrenceNotClosedTitle: 'This audit is not finished yet',
  occurrenceNotClosedMessage:
    'This audit is not finished yet. If you send it now, the recipient will get a PDF marked "Not finished" ' +
    'and with the current progress score (it may change once finished). If you are done answering it, press FINISH first; if you just finished it, wait a few ' +
    'seconds for it to sync.',
  occurrenceNotClosedOk: 'Send anyway',
  occurrenceNotClosedCancel: 'Wait',
  occurrenceLoadError: 'Could not load the audit. Check your connection and try again.',
  taskAutoCreateFailed: 'Could not create the automatic task. Please try again.',
  // Photos that did NOT reach the server (anti silent-loss)
  photoSection: 'Photos not uploaded',
  photoIssuesCount: '{count} photo(s) not uploaded',
  photoMissing: 'Unrecoverable photo (it did not reach the server)',
  photoCaptureFailed: 'Could not save the photo — please take it again',
  photoOrphan: 'Unattached photo — please take it again',
  photoRef: 'Reference: {ref}',
  photoAck: 'Got it',
  actionError: 'Could not complete the action. Please try again.',
  answersNotSent: '{n} answer(s) of this form could not be sent to the server. ' +
    'They are kept on the device: check the "Failed" section of the sync panel to retry.',
  saveAnswerFailed: 'Could not save the answer offline. Please try again.',
  photoSaveFailed: 'Could not save the photo offline. Please try again.',
  videoSaveFailed: 'Could not save the video offline. Please try again.',
  photoNotDownloaded: 'This photo is not downloaded on the device',
  photoNotDownloadedHint: 'Connect to the internet to view and edit it. Your offline work is not lost.',
  photoLoadFailed: 'Could not load the image',
  photoLoadFailedHint: 'Please try again. If it keeps failing, the photo may be damaged.',
  photoRetry: 'Retry',
  resyncingComments: 'Re-syncing comments...',
  shareDiagnostic: 'Share diagnostics',
  qaModeOn: 'Diagnostic mode ON — use the bug icon to share the report',
  qaModeOff: 'Diagnostic mode off'
}
